import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const IS_SENTRY_ENABLED = SENTRY_DSN != "";

export function captureException(e: unknown) {
    if (IS_SENTRY_ENABLED) {
        Sentry.captureException(e);
    }
}

if (IS_SENTRY_ENABLED) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration(), Sentry.httpClientIntegration()],
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        tracePropagationTargets: ["127.0.0.1", process.env.PUBLIC_URL],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}
